/**
 * Google Places autocomplete predictions arrive in a few shapes across API
 * surfaces and versions. These normalise the two pieces of text we need.
 */

/** Full label, e.g. "RTA Office Pileru, Punganur-Piler-Tirupati Rd, Regullu". */
export const predictionText = (prediction) => {
  const text = prediction?.text;
  if (typeof text === 'string') return text;
  if (text?.text) return text.text;
  return prediction?.structuredFormat?.mainText?.text
    || prediction?.mainText?.text
    || '';
};

/**
 * Just the place name, e.g. "RTA Office Pileru" — for a last-resort geocode
 * query. The address tail ("…, Punganur-Piler-Tirupati Rd, …") otherwise gets
 * resolved to the middle of that road, kilometres from the actual place.
 */
export const predictionMainText = (prediction) => {
  const main = prediction?.structuredFormat?.mainText?.text
    || prediction?.mainText?.text;
  if (main) return String(main).trim();
  const full = predictionText(prediction);
  return full ? full.split(',')[0].trim() : '';
};
